import React from "react";
import { PublicListData } from "@/entry/server/user";
import { ASSETS_BASE_URL } from "@/utils/constants";
import { Link } from "react-router-dom";
import UserCircleIcon from "@public/img/user-circle.svg";
export default function ListItem({ list }: { list: PublicListData }) {
    return (
        <Link to={`/lists/${list.id}`} className="w-full flex flex-col gap-2 bg-main-bg rounded-2xl p-3.5 border border-zinc-600 z-10">
            <div className="w-full grid grid-cols-3 gap-2">
                {list.thumbnails.map((thumbnail, index) => (
                    <div key={index}>
                        {index < 5 || list.movie_count <= 6 ? (
                            <img src={thumbnail.startsWith("http") ? thumbnail : `${ASSETS_BASE_URL}${thumbnail}`} alt={list.name} className="w-full aspect-square object-cover rounded-2xl" />
                        ) : <div className="w-full aspect-square rounded-2xl overflow-clip relative" >
                                <img src={thumbnail.startsWith("http") ? thumbnail : `${ASSETS_BASE_URL}${thumbnail}`} alt={list.name} className="w-full aspect-square object-cover rounded-2xl" />
                                <div className="w-full aspect-square bg-black/70 rounded-2xl flex items-center justify-center absolute top-0 left-0">
                                    <span className="text-2xl font-extrabold ltr">+{list.movie_count - 6}</span>
                                </div>
                            </div>}
                    </div>
                ))}

                {list.movie_count < 6 && Array.from({ length: 6 - list.movie_count }).map((_, index) => (
                    <div key={index} className="w-full aspect-square" />
                ))}
            </div>
            <p className="text-lg font-bold line-clamp-1">{list.name}</p>
            <div className="w-full flex items-center gap-2">
                <img src={UserCircleIcon} alt="User" />
                <p className="text-sm line-clamp-1">{list.username}</p>
                <p className="text-sm mr-auto line-clamp-1">{list.created_at}</p>
            </div>
        </Link>
    )
}